
import { createReducer, on } from '@ngrx/store';
import { memberFormConfigData, memberFormConfigDataSuccess, memberFormConfigDataFailure } from '../actions/memberFormConfig.actions';

export interface State {
  memberFormConfigData: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: State = {
  memberFormConfigData: [],
  loading: false,
  error: null,
};

export const memberFormConfigReducer = createReducer(
  initialState,
  on(memberFormConfigData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(memberFormConfigDataSuccess, (state, { memberFormConfigData }) => {
    console.log({memberFormConfigData})
    return ({
    ...state,
    loading: false,
    memberFormConfigData: memberFormConfigData,
  })}),
  on(memberFormConfigDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
